// Tiny DOM helper. Keeps screen code readable without pulling in a framework,
// and avoids innerHTML entirely (everything is createElement + textContent).

export function el(tag, attrs = {}, children = []) {
  const node = document.createElement(tag);
  for (const [k, v] of Object.entries(attrs)) {
    if (v === undefined || v === null || v === false) continue;
    if (k === 'class') node.className = v;
    else if (k === 'text') node.textContent = v;
    else if (k === 'html') throw new Error('el(): html is not supported; use text or children');
    else if (k.startsWith('on') && typeof v === 'function') {
      node.addEventListener(k.slice(2).toLowerCase(), v);
    } else if (k === 'for') node.htmlFor = v;
    else if (k === 'src' || k === 'href' || k === 'alt') node.setAttribute(k, v);
    else if (k in node) node[k] = v;
    else node.setAttribute(k, v);
  }
  const list = Array.isArray(children) ? children : [children];
  for (const c of list) {
    if (c === undefined || c === null || c === false) continue;
    node.appendChild(typeof c === 'string' ? document.createTextNode(c) : c);
  }
  return node;
}

export function progress({ step, total }) {
  const bar = el('div', { class: 'progress', 'aria-label': `Step ${step} of ${total}` });
  for (let i = 0; i < total; i += 1) {
    bar.appendChild(el('span', { class: i < step ? 'on' : '' }));
  }
  return bar;
}

export function example({ label, src, caption }) {
  return el('figure', { class: 'example' }, [
    el('figcaption', { class: 'example-label', text: label }),
    el('img', { class: 'example-photo', src, alt: caption }),
    caption ? el('figcaption', { class: 'example-caption', text: caption }) : null,
  ]);
}

// Render the post-upload recognition card. Shows extracted fields in the
// OK case, a retake-hint in the unrecognized case.
export function resultCard({ recognized, extraction, resultCopy }) {
  const card = el('div', { class: recognized ? 'result-card ok' : 'result-card warn' });
  card.appendChild(
    el('div', { class: 'headline' }, [
      el('span', { class: 'badge', text: recognized ? '✓' : '!' }),
      recognized ? resultCopy.recognizedTitle : resultCopy.unrecognizedTitle,
    ]),
  );
  if (recognized && extraction) {
    const dl = el('dl', { class: 'details' });
    const fields = [
      ['vendor', resultCopy.fieldVendor],
      ['model', resultCopy.fieldModel],
      ['hardwareRev', resultCopy.fieldHardware],
      ['serial', resultCopy.fieldSerial],
      ['macAddress', resultCopy.fieldMac],
      ['wifiSSID', resultCopy.fieldSsid],
    ];
    for (const [key, label] of fields) {
      const value = extraction[key];
      if (!value) continue;
      dl.appendChild(el('dt', { text: label }));
      dl.appendChild(el('dd', { text: value }));
    }
    card.appendChild(dl);
    card.appendChild(el('p', { class: 'result-note', text: resultCopy.recognizedHint }));
  } else {
    card.appendChild(el('p', { class: 'result-note', text: resultCopy.unrecognizedHint }));
  }
  return card;
}
